/* cw-slot-editor — visual media CMS overlay for any page of the site.

   How you get in: add ?cwedit=1 (or #cwedit) to any page and enter the admin
   password. There is deliberately no button on the page — a customer should
   never see an editing control — so this URL is the whole entry point.

   It then outlines every replaceable picture and video on the real page, lets
   you pick a replacement from the gallery, previews it live, and saves.

   Nothing here needs a local server. Both kinds of spot are saved straight to
   shop metafields through the admin proxy, so the site is editable from any
   browser that knows the admin password:

   * raw <img>/<video> (blue)  — a rule in custom.media_swaps, keyed by the
     file the page shipped with, applied on load by snippets/cw-media-swaps.
   * [data-cw-slot] (gold)     — a placement in custom.media_slots, which the
     cw-slot loader in theme.liquid merges over assets/cw-slots.json.

   The picker lists the real gallery: the 500-odd rows in custom.gallery_data
   plus everything in cw-content-assets.json, videos and GIFs included. */
(function () {
  var params = new URLSearchParams(location.search);
  /* ?cwedit=1 still works as a direct link, but the site-wide flag set by the
     admin page's "Edit website" button now turns this on too — one button for
     page media and the gallery both. */
  var wants = params.get('cwedit') === '1' || location.hash.indexOf('cwedit') >= 0
              || !!(window.cwAdminGate && window.cwAdminGate.isEditing());
  if (!wants) return;

  var PROXY = 'https://cyclewash-admin-proxy.vvlars.workers.dev/rest/graphql.json';
  var SHOP_GID = 'gid://shopify/Shop/27217166471';
  var PW_KEY = 'cw-gal-save-pw';
  var ASSETS = document.currentScript.getAttribute('data-assets');
  var BASE = ASSETS.split('cw-content-assets.json')[0];
  var gallery = [], pw = null;
  /* what is already live, so Save never drops a rule this page did not touch */
  var rules = (window.__cwMediaSwaps || []).slice();
  var slots = Object.assign({}, window.__cwMediaSlots || {});
  var pendingSwaps = [], pendingSlots = {}, dirty = 0;
  function countDirty() {
    dirty = pendingSwaps.length + Object.keys(pendingSlots).length;
  }

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); }
    catch (e) { return v === undefined ? null : v; }
  }
  function resolve(src) {
    return /^https?:\/\//.test(src) ? src : (src.charAt(0) === '/' ? BASE + src.slice(1) : BASE + src);
  }
  function gql(query, variables) {
    return fetch(PROXY, {
      method: 'POST',
      headers: {'content-type': 'application/json', 'X-CW-Admin-Pass': pw},
      body: JSON.stringify({query: query, variables: variables || {}})
    }).then(function (r) {
      if (r.status === 401 || r.status === 403) throw new Error('auth');
      if (!r.ok) throw new Error('proxy HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d.errors && d.errors.length) throw new Error(d.errors[0].message);
      return d.data;
    });
  }
  /* Same gate and same stored password as the gallery's own edit mode, so the
     owner is asked once per tab at most. */
  function ensureAuth() {
    if (pw) return Promise.resolve(true);
    /* The masked dialog, the stored password and the re-check all live in
       cw-admin-gate.js, so this editor and the gallery's behave identically
       and the owner is asked at most once. */
    var first = window.cwAdminGate.getPass('Edit this page').then(function (v) {
      if (!v) return false;
      pw = v; ss(PW_KEY, v);
      return true;
    });
    return first.catch(function (e) {
      alert('Could not reach the admin proxy: ' + e.message);
      return false;
    });
  }

  var css = document.createElement('style');
  css.textContent = [
    '.cwse-mark{position:absolute;z-index:99998;pointer-events:none;border:2px dashed #FFC300;border-radius:8px;box-shadow:0 0 0 9999px rgba(0,0,0,0)}',
    '.cwse-badge{position:absolute;z-index:99999;transform:translateY(-100%);background:#0F1521;color:#FFC300;font:600 12px/1 Inter,sans-serif;padding:6px 10px;border-radius:7px 7px 0 0;border:1px solid #FFC300;cursor:pointer;display:flex;gap:8px;align-items:center;white-space:nowrap}',
    '.cwse-badge b{color:#fff}',
    '.cwse-badge .cwse-swap{background:#FFC300;color:#14181f;border-radius:5px;padding:2px 7px;font-weight:700}',
    '.cwse-mark2{position:absolute;z-index:99997;pointer-events:none;border:2px dashed #1E82C8;border-radius:8px}',
    '.cwse-badge2{position:absolute;z-index:99999;transform:translateY(-100%);background:#0F1521;color:#5BB8F5;font:600 11px/1 Inter,sans-serif;padding:5px 9px;border-radius:7px 7px 0 0;border:1px solid #1E82C8;cursor:pointer;display:flex;gap:7px;align-items:center;white-space:nowrap;max-width:340px;overflow:hidden}',
    '.cwse-badge2 .cwse-swap{background:#1E82C8;color:#fff;border-radius:5px;padding:2px 7px;font-weight:700}',
    '.cwse-badge2 .cwse-undo{background:transparent;color:#9fb3c8;border:1px solid #33465c;border-radius:5px;padding:2px 6px}',
    '.cwse-bar{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:100001;background:#0F1521;border:1px solid #26303F;border-radius:12px;padding:10px 16px;display:flex;gap:12px;align-items:center;color:#C5CCD8;font:13px Inter,sans-serif;box-shadow:0 16px 50px rgba(0,0,0,.5)}',
    '.cwse-bar button{font:inherit;font-weight:700;border:0;border-radius:8px;padding:8px 16px;cursor:pointer}',
    '.cwse-pub{background:#FFC300;color:#14181f}.cwse-pub:disabled{opacity:.4}',
    '.cwse-off{background:transparent;color:#828B9C;border:1px solid #26303F !important}',
    '.cwse-dot{width:8px;height:8px;border-radius:50%;background:#e5534b}.cwse-dot.on{background:#3fbf6f}',
    '.cwse-modal{position:fixed;inset:0;z-index:100002;background:rgba(6,9,14,.85);display:none;flex-direction:column;padding:3vh 3vw}',
    '.cwse-modal.open{display:flex}',
    '.cwse-mhead{display:flex;gap:12px;align-items:center;margin-bottom:12px;color:#fff;font:600 15px Inter;flex-wrap:wrap}',
    '.cwse-mhead input,.cwse-mhead select{font:13px Inter;background:#141B28;color:#F4F7FB;border:1px solid #26303F;border-radius:8px;padding:8px 12px}',
    '.cwse-mhead label{font:12px Inter;color:#9fb3c8;display:flex;gap:6px;align-items:center}',
    '.cwse-mhead .cwse-x{margin-left:auto;background:#141B28;color:#fff;border:1px solid #26303F;border-radius:8px;padding:8px 14px;cursor:pointer}',
    '.cwse-grid{flex:1;overflow:auto;display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));grid-auto-rows:150px;gap:10px;align-content:start}',
    '.cwse-cell{position:relative;height:150px !important;border-radius:10px;overflow:hidden;border:2px solid transparent;cursor:pointer;background:#0d1420;margin:0 !important;padding:0 !important}',
    '.cwse-cell img,.cwse-cell video{width:100% !important;height:100% !important;max-width:none !important;max-height:none !important;min-height:0 !important;object-fit:cover !important;display:block !important;margin:0 !important;border-radius:0 !important;opacity:1 !important;transform:none !important}',
    '.cwse-cell:hover{border-color:#1E82C8}.cwse-cell .cwse-v{position:absolute;top:6px;right:6px;background:rgba(10,15,22,.7);color:#fff;border-radius:5px;padding:1px 5px;font:10px Inter}',
    '.cwse-empty{color:#9fb3c8;font:13px Inter;padding:20px}'
  ].join('\n');
  document.head.appendChild(css);

  var modal = document.createElement('div');
  modal.className = 'cwse-modal';
  modal.innerHTML = '<div class="cwse-mhead"><b id="cwse-mtitle">Pick media</b>' +
    '<input id="cwse-msearch" placeholder="search…"><select id="cwse-mcat"></select>' +
    '<label><input type="checkbox" id="cwse-mall"> replace on every page</label>' +
    '<button class="cwse-x" id="cwse-mx">Close</button></div>' +
    '<div class="cwse-grid" id="cwse-mgrid"></div>';
  document.body.appendChild(modal);
  var activeSlot = null, activeEl = null, activeSwap = null;

  function normPage() {
    var p = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/';
    return p.length > 1 ? p.replace(/\/$/, '') : p;
  }
  function imgKey(im) {
    var s = im.getAttribute('src') || '';
    if (!s && im.tagName === 'VIDEO') { var so = im.querySelector('source'); s = so ? (so.getAttribute('src') || '') : ''; }
    return s.split('?')[0].split('/').pop().toLowerCase();
  }
  /* The rule has to name the file the page shipped with, not the one currently
     on screen — otherwise editing the same spot twice writes a rule that
     matches nothing on the next load. */
  function originalKey(im) {
    return im.dataset.cwseOrig || (im.dataset.cwseOrig = imgKey(im));
  }

  function openSwapPicker(im) {
    activeSwap = {img: im, match: originalKey(im), video: im.tagName === 'VIDEO'};
    activeSlot = null; activeEl = null;
    document.getElementById('cwse-mtitle').innerHTML =
      'Replace ' + (activeSwap.video ? 'video ' : '') +
      '<span style="color:#5BB8F5">' + activeSwap.match + '</span>' +
      (activeSwap.video ? ' — pick a video' : ' — pick an image');
    document.getElementById('cwse-mall').checked = false;
    fillCats(); renderGrid(); modal.classList.add('open');
  }
  function fillCats() {
    var cats = [], seen = {};
    gallery.forEach(function (a) { var c = a.category; if (c && !seen[c]) { seen[c] = 1; cats.push(c); } });
    cats.sort();
    document.getElementById('cwse-mcat').innerHTML = '<option value="">all categories</option>' +
      cats.map(function (c) { return '<option>' + c + '</option>'; }).join('');
  }
  function openPicker(slotId, el) {
    activeSlot = slotId; activeEl = el; activeSwap = null;
    document.getElementById('cwse-mtitle').innerHTML =
      'Pick media for <span style="color:#FFC300">' + slotId + '</span>';
    fillCats(); renderGrid(); modal.classList.add('open');
  }
  function renderGrid() {
    var q = (document.getElementById('cwse-msearch').value || '').toLowerCase();
    var cat = document.getElementById('cwse-mcat').value;
    var grid = document.getElementById('cwse-mgrid');
    grid.innerHTML = '';
    var seen = {}, n = 0;
    /* A video spot can only take a video, and vice versa — filter rather than
       let the owner pick something that will be rejected on click. */
    var wantVideo = activeSwap ? !!activeSwap.video : null;
    gallery.forEach(function (a) {
      if (a.extra) return;
      if (cat && a.category !== cat) return;
      if (wantVideo !== null && !!a.video !== wantVideo) return;
      var src = resolve(a.url || a.asset || '');
      if (!src) return;
      var key = src.split('?')[0].split('/').pop().toLowerCase();
      if (seen[key]) return;
      seen[key] = 1;
      if (q && (a.category + ' ' + (a.file || '') + ' ' + src).toLowerCase().indexOf(q) < 0) return;
      var thumb = (!a.video && /cdn\.shopify\.com|\/cdn\/shop\//.test(src))
        ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=320'
        : src;
      var cell = document.createElement('div');
      cell.className = 'cwse-cell';
      cell.innerHTML = a.video
        ? '<video muted preload="none"' + (a.poster ? ' poster="' + resolve(a.poster) + '"' : '') +
          ' src="' + src + '"></video><span class="cwse-v">▶</span>'
        : '<img loading="lazy" decoding="async" src="' + thumb + '">';
      cell.title = (a.category || '') + ' · ' + (a.file || key);
      cell.onclick = function () { assign(a, src); };
      grid.appendChild(cell);
      n++;
    });
    if (!n) {
      grid.innerHTML = '<p class="cwse-empty">Nothing in the gallery matches' +
        (wantVideo === true ? ' — this spot needs a video.' : '.') + '</p>';
    }
  }

  /* Live preview of a swap, same DOM surgery cw-media-swaps does on load. */
  function paint(im, src, poster) {
    if (im.tagName === 'VIDEO') {
      im.querySelectorAll('source').forEach(function (so) { so.remove(); });
      im.src = src;
      if (poster) im.poster = poster;
      try { im.load(); } catch (e) {}
      if (im.autoplay || im.muted) { var p = im.play(); if (p && p.catch) p.catch(function () {}); }
      return;
    }
    im.src = src;
    im.removeAttribute('srcset');
    im.removeAttribute('sizes');
    var pic = im.closest('picture');
    if (pic) pic.querySelectorAll('source').forEach(function (so) { so.remove(); });
  }

  function assign(a, src) {
    if (activeSwap) {
      if (activeSwap.video !== !!a.video) {
        alert(activeSwap.video ? 'This spot is a video — pick a video.' : 'This spot is an image — pick an image.');
        return;
      }
      var rule = {
        page: document.getElementById('cwse-mall').checked ? '*' : normPage(),
        match: activeSwap.match,
        src: src
      };
      if (a.video) { rule.video = 1; if (a.poster) rule.po = resolve(a.poster); }
      /* one rule per spot: a second pick replaces the queued one */
      pendingSwaps = pendingSwaps.filter(function (s) { return s.match !== rule.match; });
      pendingSwaps.push(rule);
      paint(activeSwap.img, src, rule.po);
      countDirty();
      updateBar();
      modal.classList.remove('open');
      scheduleDraw();
      return;
    }
    /* Slot placements are queued exactly like swaps and land in the
       custom.media_slots metafield on Save — no pipeline, no file id. */
    var item = {src: src, category: a.category || ''};
    if (a.video) { item.video = 1; if (a.poster) item.poster = resolve(a.poster); }
    pendingSlots[activeSlot] = [item];
    activeEl.innerHTML = a.video
      ? '<button class="cw-slot__media cw-slot__video" type="button"><video muted preload="none"' +
        (item.poster ? ' poster="' + item.poster + '"' : '') + ' src="' + src + '"></video>' +
        '<span class="cw-slot__play">▶</span></button>'
      : '<img class="cw-slot__media" src="' + src + '">';
    activeEl.setAttribute('data-cw-filled', '1');
    countDirty();
    updateBar();
    modal.classList.remove('open');
    scheduleDraw();
  }
  document.getElementById('cwse-mx').onclick = function () { modal.classList.remove('open'); };
  document.getElementById('cwse-msearch').oninput = renderGrid;
  document.getElementById('cwse-mcat').onchange = renderGrid;

  var bar = document.createElement('div');
  bar.className = 'cwse-bar';
  bar.innerHTML = '<span class="cwse-dot" id="cwse-dot"></span><span id="cwse-status">Website editor</span>' +
    '<button class="cwse-pub" id="cwse-pub" disabled>Save</button>' +
    '<button class="cwse-off" id="cwse-exit">Exit</button>';
  document.body.appendChild(bar);
  function updateBar() {
    document.getElementById('cwse-status').textContent = dirty
      ? dirty + ' change' + (dirty > 1 ? 's' : '') + ' pending'
      : 'Website editor · ready';
    document.getElementById('cwse-dot').className = 'cwse-dot' + (pw ? ' on' : '');
    document.getElementById('cwse-pub').disabled = !dirty;
  }

  document.getElementById('cwse-pub').onclick = function () {
    var b = this, label = b.textContent;
    if (!dirty) return;
    b.textContent = 'Saving…'; b.disabled = true;

    /* merge: a new rule for the same page+file replaces the old one */
    var keep = rules.filter(function (r) {
      return !pendingSwaps.some(function (p) { return p.match === r.match && p.page === r.page; });
    });
    var nextRules = keep.concat(pendingSwaps);
    var nextSlots = Object.assign({}, slots, pendingSlots);

    var fields = [];
    if (pendingSwaps.length) fields.push({key: 'media_swaps', value: JSON.stringify(nextRules)});
    if (Object.keys(pendingSlots).length) fields.push({key: 'media_slots', value: JSON.stringify(nextSlots)});

    gql('mutation($m:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$m){ userErrors{ field message } } }',
      {m: fields.map(function (f) {
        return {ownerId: SHOP_GID, namespace: 'custom', key: f.key, type: 'json', value: f.value};
      })})
      .then(function (d) {
        var errs = ((d.metafieldsSet || {}).userErrors) || [];
        if (errs.length) throw new Error(errs[0].message);
        rules = nextRules;
        slots = nextSlots;
        pendingSwaps = []; pendingSlots = {};
        countDirty();
        b.textContent = '✓ Saved';
        updateBar();
        setTimeout(function () { b.textContent = label; }, 2000);
      })
      .catch(function (e) {
        b.textContent = label; b.disabled = false;
        if (e.message === 'auth') { pw = null; alert('Wrong admin password — reload and try again.'); return; }
        alert('Could not save: ' + e.message);
      });
  };
  document.getElementById('cwse-exit').onclick = function () {
    if (dirty && !confirm(dirty + ' unsaved change(s) will be lost. Leave anyway?')) return;
    var u = new URL(location.href);
    u.searchParams.delete('cwedit');
    u.hash = '';
    location.href = u.toString();
  };

  function drawMarks() {
    document.querySelectorAll('.cwse-mark,.cwse-badge,.cwse-mark2,.cwse-badge2').forEach(function (n) { n.remove(); });
    document.querySelectorAll('[data-cw-slot]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) return;
      var top = r.top + scrollY, left = r.left + scrollX;
      var mark = document.createElement('div');
      mark.className = 'cwse-mark';
      mark.style.cssText += ';top:' + top + 'px;left:' + left + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
      document.body.appendChild(mark);
      var badge = document.createElement('div');
      badge.className = 'cwse-badge';
      badge.style.cssText += ';top:' + top + 'px;left:' + left + 'px';
      var sid = el.getAttribute('data-cw-slot');
      badge.innerHTML = '◎ <b>' + sid + '</b><span class="cwse-swap">⇄ replace</span>' +
        (pendingSlots[sid] ? '<span class="cwse-undo">queued</span>' : '');
      badge.querySelector('.cwse-swap').onclick = function () { openPicker(sid, el); };
      document.body.appendChild(badge);
    });
    /* every raw picture and video on the page (blue) — no wrapper needed */
    document.querySelectorAll('img,video').forEach(function (im) {
      if (im.closest('[data-cw-slot]') || im.closest('.cwse-modal') || im.closest('.cwse-bar')) return;
      var r = im.getBoundingClientRect();
      if (r.width < 90 || r.height < 60) return;   /* skip icons and logos */
      if (!imgKey(im)) return;
      var vid = im.tagName === 'VIDEO';
      var top = r.top + scrollY, left = r.left + scrollX;
      var mark = document.createElement('div');
      mark.className = 'cwse-mark2';
      mark.style.cssText += ';top:' + top + 'px;left:' + left + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
      document.body.appendChild(mark);
      var badge = document.createElement('div');
      badge.className = 'cwse-badge2';
      badge.style.cssText += ';top:' + top + 'px;left:' + left + 'px';
      var k = originalKey(im);
      var queued = pendingSwaps.some(function (s) { return s.match === k; });
      badge.innerHTML = (vid ? '🎞' : '🖼') + ' <b>' + k.slice(0, 34) + '</b>' +
        '<span class="cwse-swap">⇄ replace</span>' +
        (queued ? '<span class="cwse-undo">queued</span>' : '');
      badge.querySelector('.cwse-swap').onclick = function () { openSwapPicker(im); };
      document.body.appendChild(badge);
    });
  }
  var raf;
  function scheduleDraw() { cancelAnimationFrame(raf); raf = requestAnimationFrame(drawMarks); }
  addEventListener('scroll', scheduleDraw, {passive: true});
  addEventListener('resize', scheduleDraw);

  /* The picker is only as good as the gallery behind it: the metafield rows are
     the curated gallery, cw-content-assets.json is everything ImagePipe knows
     about. Both, de-duplicated by filename at render time. */
  function loadGallery() {
    var fromJson = fetch(ASSETS).then(function (r) { return r.json(); })
      .then(function (d) {
        return (d.assets || []).filter(function (a) { return a && (a.url || a.asset); });
      })
      .catch(function () { return []; });
    var fromMetafield = gql('{ shop { metafield(namespace:"custom",key:"gallery_data"){ value } } }')
      .then(function (d) {
        var mf = ((d.shop || {}).metafield || {}).value;
        if (!mf) return [];
        return JSON.parse(mf).map(function (r) {
          var isUrl = String(r.a).indexOf('//') !== -1;
          return {
            category: String(r.c).split(' ')[0],
            video: r.v ? 1 : 0,
            poster: r.po || '',
            file: '',
            /* bare filenames in the metafield are theme assets */
            url: isUrl ? r.a : '',
            asset: isUrl ? '' : r.a
          };
        });
      })
      .catch(function () { return []; });
    return Promise.all([fromMetafield, fromJson]).then(function (parts) {
      gallery = parts[0].concat(parts[1]);
    });
  }

  ensureAuth().then(function (ok) {
    if (!ok) {
      document.getElementById('cwse-status').textContent = 'Locked — reload to try again';
      return;
    }
    updateBar();
    loadGallery().then(function () {
      updateBar();
      setTimeout(drawMarks, 400);
    });
  });
})();
